<template>
    <div class="modal-wrapper" @click="close">
		<div class="modal-container modal-container-full" @click.stop.prevent="() => false">
			<div class="modal-header">
				<div class="row">
					<div class="col-xs-12 col-lg-12">
						SINCRONIZAR MOTORISTAS
						<button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
					</div>
				</div>
			</div>
			<div class="modal-body modal-body-full">
                <div v-if="loading" class="row">
                    <div class="col-xs-12 col-lg-12">
                        <div class="loading loading-full">
                            <span v-if="view == 'selection'" class="loading-icon"><i class="fa fa-circle-notch fa-spin"></i></span>
                            <span v-else class="loading-percent"><b>{{ percent }}%</b></span>
                            <span class="loading-text">{{ loading_text }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="view == 'selection'" class="row">
                    <div class="col-xs">
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-12 col-lg-offset-2 col-lg-4 list-search">
                                    <FormInput v-model="form.search" label="Busque o motorista" type="text" icon="fa-search" tooltip="Informe uma palavra-chave para filtragem dos registros" ref="search" />
                                </div>
                                <div class="col-xs-12 col-lg-4 list-search">
                                    <FormSelect v-model="form.filter" label="Exibir motoristas" :options="form.options" icon="fa-sort" @blur="searchedList()" tooltip="Selecione a exbição do tipo de registro" ref="filter" />
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-12 col-lg-6 start-xs list-name"><h4>Motoristas</h4></div>
                                <div class="col-xs-12 col-lg-6 end-xs list-total text-right"><h4>Selecionados: {{ selected.length }} de {{ list.length }}</h4></div>
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="row list-head">
                                <div class="col-xs-1 list-head-item pointer" @click="onSelectAll()"><i class="fa-fw" :class="selected.length == list.length ? 'fas fa-check-square' : 'far fa-square'"></i></div>
                                <div class="col-xs-1 list-head-item">Registro</div>
                                <div class="col-xs-3 list-head-item">Nome</div>
                                <div class="col-xs-2 list-head-item">CPF</div>
                                <div class="col-xs-2 list-head-item">E-mail</div>
                                <div class="col-xs-1 list-head-item">Telefone</div>
                                <div class="col-xs-2 list-head-item">Situação</div>
                            </div>
                        </div>
                        <div v-if="searchedList().length > 0" class="col-xs-12 list list-body">
                            <div v-for="(register, index) in searchedList()" :key="'register-' + index" class="row list-body-item">
                                <div class="col-xs-1 list-body-item-text pointer" @click="onSelect(register)"><i class="fa-fw" :class="selected.includes(register) ? 'fas fa-check-square' : 'far fa-square'"></i></div>
                                <div class="col-xs-1 list-body-item-text">{{ register.code }}</div>
                                <div class="col-xs-3 list-body-item-text">{{ register.name }}</div>
                                <div class="col-xs-2 list-body-item-text" :class="!register.document ? 'text-empty' : ''">{{ register.document ? getDocumentFormatted(register.document) : "Não definido" }}</div>
                                <div class="col-xs-2 list-body-item-text" :class="!register.email ? 'text-empty' : ''">{{ register.email ? register.email : "Não definido" }}</div>
                                <div class="col-xs-1 list-body-item-text" :class="(!register.phone || (register.phone == '5500000000000')) ? 'text-empty' : ''">{{ (register.phone && (register.phone != '5500000000000')) ? getPhoneFormatted(register.phone) : "Não definido" }}</div>
                                <div class="col-xs-2 list-body-item-text resume">
                                    <span v-if="loading" ><i>Analisando...</i></span>
                                    <span v-else :class="register.error ? 'error' : 'success'">{{ register.message }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-xs-12 text-center">
                            <small><i>Não foram encontrados registros de motoristas.</i></small>
                        </div>
                    </div>
                </div>
                <div v-else-if="view == 'synchronized'" class="row">
                    <div class="col-xs">
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-12 col-lg-6 start-xs list-name"><h4>Motoristas</h4></div>
                                <div class="col-xs-12 col-lg-6 end-xs list-total text-right"><h4>Processados: {{ selected.length }} de {{ list.length }}</h4></div>
                            </div>
                        </div>
                        <div class="col-xs-12">
                            <div class="row list-head">
                                <div class="col-xs-1 list-head-item">#</div>
                                <div class="col-xs-1 list-head-item">Registro</div>
                                <div class="col-xs-3 list-head-item">Nome</div>
                                <div class="col-xs-2 list-head-item">CPF</div>
                                <div class="col-xs-2 list-head-item">E-mail</div>
                                <div class="col-xs-1 list-head-item">Telefone</div>
                                <div class="col-xs-2 list-head-item">Resumo</div>
                            </div>
                        </div>
                        <div v-if="selected.length > 0" class="col-xs-12 list-body">
                            <div v-for="(register, index) in selected" :key="'register-' + index" class="row list-body-item">
                                <div class="col-xs-1 list-body-item-text">
                                    <span v-if="!register.uploaded" class="gray"><i class="fas fa-fw fa-circle-notch fa-spin"></i></span>
                                    <span v-else :class="(register.error && (register.message != 'Motorista sincronizado e vinculado.')) ? 'error' : 'success'"><i class="fas fa-fw" :class="(register.error && (register.message != 'Motorista sincronizado e vinculado.')) ? 'fa-times-circle' : 'fa-check-circle'"></i></span>
                                </div>
                                <div class="col-xs-1 list-body-item-text">{{ register.code }}</div>
                                <div class="col-xs-3 list-body-item-text">{{ register.name }}</div>
                                <div class="col-xs-2 list-body-item-text" :class="!register.document ? 'text-empty' : '' ">{{ register.document ? getDocumentFormatted(register.document) : "Não definido" }}</div>
                                <div class="col-xs-2 list-body-item-text" :class="!register.email ? 'text-empty' : '' ">{{ register.email ? register.email : "Não definido" }}</div>
                                <div class="col-xs-1 list-body-item-text" :class="(!register.phone || (register.phone == '5500000000000')) ? 'text-empty' : ''">{{ (register.phone && (register.phone != '5500000000000')) ? getPhoneFormatted(register.phone) : "Não definido" }}</div>
                                <div class="col-xs-2 list-body-item-text resume">
                                    <span v-if="register.uploaded" :class="(register.error && (register.message != 'Motorista sincronizado e vinculado.')) ? 'error' : 'success'">{{ register.message }}</span>
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-xs-12 text-center">
                            <small><i>Não foram encontrados registros de motoristas sincronizados.</i></small>
                        </div>
                    </div>
                </div>
			</div>
			<div class="modal-footer">
				<div v-if="view == 'selection'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> CANCELAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="sync">
                            SALVAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-download'"></i>
                        </button>
                        <button class="modal-button-research" :disabled="loading" @click="getDrivers">
                            BUSCAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-search'"></i>
                        </button>
                    </div>
                </div>
                <div v-else-if="view == 'synchronized'" class="row">
                    <div class="col-xs-6">
                        <button class="modal-button-close" @click="close" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i> FECHAR
                        </button>
                        <button class="modal-button-back" @click="back" :disabled="loading">
                            <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-angle-left'"></i> VOLTAR
                        </button>
                    </div>
                    <div class="col-xs-6">
                        <button class="modal-button-save" :disabled="loading" @click="close">
                            FECHAR <i class="fas fa-fw" :class="loading ? 'fa-circle-notch fa-spin' : 'fa-times'"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";

export default {
	name: "DriverSynchronizationAtak",

	props: {
        integration: {
            type: String,
            require: false,
            default: "",
        },
        url_api_atak: {
            type: String,
            require: true,
        }
    },

	components: {
        FormInput,
        FormSelect,
    },

	data: function() {
		return {
			loading: false,
            loading_text: "",
            
            view: "selection",

            form: {
                selection: 1,
                search: "",
                filter: "",
                options: {
                    "all": "Todas os registros",
                    "ready": "Pronto para sincronizar",
                    "with_error": "Com erro",
                }
            },
            url: this.url_api_atak,
            
            list: [],
            selected: [],
            
            count: 0,
            percent: 0,
		}
	},

    mounted: function() {
        if(this.integration == "") {
            if (!this.$api.user.company_client_atak) { 
                this.$notification.error("Configuração de integração não selecionada em: Configurações -> Roteirização.");
                this.$emit("close");
                return;
            }
        }

        if(this.url_api_atak == "") {
            this.$notification.error("Endereço da API de integração não informado em: Configurações -> Roteirização.");
            this.$emit("close");
            return;
        }
        
        this.getDrivers();
    },

	methods: {
        /**
         *  Autentica com a Web API Atak
         */
         auth: async function() {
            // Inicia as informações necessárias
            let result = false;
            let data = {};
            
            // Define a url da API
            data.integration = this.integration;
            data.url = this.url;
            this.loading_text = "Solicitando autorização...";
            
            // Inicia a requisição
            try {
                result = await Api.post("synchronizer/auth", data);
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível conectar com o sistema integrado.");
                return false;
            }
            // Finaliza a requisição
            
            // Verifica o resultado
            if (result) {
                // Verifica se houve error
                if (result.error) {
					if (result.data == "unauthorized") {
						this.$notification.error("Desculpe, sua sessão expirou.");
						setTimeout(() => { 
							Api.logout();
							return;
						}, 2000);
					} else {
						this.$notification.error(result.data);
						return false;
					}
				} else {
                    return result.data;
                }
            } else {
                this.$notification.error("Não foi possível obter a autorização do sistema integrado.");
                return false;
            }
		},

        /**
         * Busca com os dados de motorista no sistema integrado
         */
        getDrivers: async function() {
            // Inicia a sincronização
            this.loading = true;
            
            // Obtém o token de autorização
            let token = await this.auth();
            
            // Verifica se pode obtido o token
            if(token) {
                // Define o resultado
                this.list = [];
                this.selected = [];
                let result = false;
                this.loading_text = "Buscando motoristas...";
                // Faz o request
                try {
                    result = await Api.post("synchronizer/get-drivers", {
                        integration: this.integration,
                        url: this.url,
                        token: token,
                        date: this.form.date
                    });
                } catch (ex) {
                    console.log(ex);
                    this.$notification.error("Não foi possível sincronizar os motoristas.");
                    this.loading = false;
                    this.loading_text = "";
                    return false;
                }
                
                // Verifica se houve error
                if (result.error) {
                    this.$notification.error(result.data);
                    this.loading = false;
                    this.loading_text = "";
                    return false;
                } else {
                    // Verifica se houve
                    if(result) {
                        if (result.error) {
                            if (result.data == "unauthorized") {
                                // Notifica o fim da sessão
                                this.$notification.error("Desculpe, sua sessão expirou.");
                                setTimeout(() => { 
                                    Api.logout();
                                    return;
                                }, 2000);
                            } else {
                                // Notifica o erro
                                this.$notification.error(result.data);
                                
                                // Finaliza a sincronização
                                this.loading = false;
                                return;
                            }
                        } else {
                            if(result.total > 0) {
                                // Define o texto de feedback atual
                                this.loading_text = "";

                                // Percorre a lista buscando o restante das informações
                                for (let register of result.data) {
                                    // Atualiza a div
                                    this.$forceUpdate();
                                    
                                    // Define a lista
                                    this.list.push(register);

                                    // Verifica se tem error
                                    if (!register.error) {
                                        this.selected.push(register);
                                    }

                                    // Atualiza a div
                                    this.$forceUpdate();
                                }

                                // Inicia a sincronização
                                this.loading = false;
                            } else {
                                // Retorna o modal ao formulário
                                this.view = "selection";
                                this.$notification.error("Não foram encontrados registros de motoristas.");

                                // Finaliza a sincronização
                                this.loading = false;
                            }
                        }
                    } else {
                        // Retorna o modal ao formulário
                        this.view = "selection";
                        this.$notification.error("Não foi possível sincronizar os motoristas.");
                        
                        // Finaliza a sincronização
                        this.loading = false;
                    }
                }
            } else {
                this.loading = false;
                return;
            }
		},

        /**
         * Salva os dados vindos do sistema integrado
         */
        sync: async function() {
            // Verifica  quantidade de selecionados
            if (this.selected.length > 0) {
                // Exibe a lista de sincronização
                this.view = "synchronized";

                // Inicia a sincronização
                this.count = 0;
                this.percent = 0;
                this.loading_text = "Sincronizando informações...";

                // Inicia a sincronização
                this.loading = true;

                // Solicita para cada registro
                for (let register of this.selected) {
                    // Verifica se tem erro
                    if (!register.error) {
                        // Faz o request
                        register.uploaded = false;

                        this.$forceUpdate();

                        // Inicia a variável de retorno
                        let result = null;
                        try {
                            result = await Api.post("synchronizer/save-driver", {data: register});
                        } catch (ex) {
                            console.log(ex);
                            register.uploaded = true;
                            register.error = true;
                            register.message = "Não foi possível sincronizar.";

                            this.count++;
                            this.calcPercent(this.count, this.selected.length);
                            continue;
                        }
                        register.uploaded = true;
                        // Termina o request
                        
                        if (result) {
                            // Verifica se houve erro
                            if (result.error) {
                                register.uploaded = true;
                                register.error = true;
                                if (result.data == "unauthorized") {
                                    register.message = "Sessão expirada.";
                                } else {
                                    register.message = result.data;
                                }
                            } else {
                                register.uploaded = true;
                                register.error = true;
                                register.message = result.data;
                            }
                        } else {
                            register.uploaded = true;
                            register.error = true;
                            register.message = "Não foi possível sincronizar.";
                        }

                        this.count++;
                        this.calcPercent(this.count, this.selected.length);

                        this.$forceUpdate();
                    }
                }

                // Encerra a sincronização
                this.loading = false;
                return;
            } else {
                this.$notification.error("Selecione ao menos um registro.");
                return;
            }
        },
        
        // Filtra com a lista
        searchedList: function() {
            if(this.form.search) {
                let exp = new RegExp(this.form.search.trim(), 'i');
                let searched_list = this.list.filter(register =>
                    exp.test(register.code) || 
                    exp.test(register.name) || 
                    exp.test(register.document) || 
                    exp.test(register.nickname) || 
                    exp.test(register.email) || 
                    exp.test(register.phone)
                );
                if (this.form.filter) {
                    return this.filtredList(searched_list);
                } else {
                    return searched_list;
                }
            } else {
               if (this.form.filter) {
                    return this.filtredList(this.list);
                } else {
                    return this.list;
                }
            }
        },

        // Filtra a lista
        filtredList: function(searched_list) {
            if (this.form.filter == "all") {
                return searched_list;
            } else if (this.form.filter == "ready") {
                return searched_list.filter(register => !register.error  ? true : false);
            } else if (this.form.filter == "with_error") {
                return searched_list.filter(register => register.error ? true : false);
            } else {
                return searched_list;
            }
        },

        // Seleciona os registros que serão syncronizados
        onSelectAll: function() {
            if (this.selected.length > 0) {
                this.selected = [];
            } else {
                this.list.map((register) => {
                    if(!register.error && !this.selected.includes(register)) {
                        this.selected.push(register);
                    }
                });
            }
        },

        // Seleciona os registros que serão syncronizados
        onSelect: function(register) {
            if (this.selected.includes(register) && !register.error) {
                let index = this.selected.indexOf(register);
                if(index !== false) {
                    this.selected.splice(index, 1);
                }
            } else {
                if (!register.error) {
                    this.selected.push(register);
                }
            }
        },

        // Volta para listagem de seleção
		back: function() {
            this.view = 'selection';
            this.onSelectAll();
		},
        
        /**
         * Retorna o documento formatado
         * @param {String} document documento do motorista
         */
        getDocumentFormatted: function(document) {
			if (document.length > 11) {
				return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
			} else {
				return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
			}
		},

        /**
         * Retorna o telefone formatado
         * @param {String} phone telephone
         */
         getPhoneFormatted: function(phone) {
			if (phone.length == 8) {
				return phone.replace(/^(\d{4})(\d{4})/, "$1-$2");
			} else if (phone.length == 9) {
				return phone.replace(/^(\d{5})(\d{4})/, "$1-$2");
			} else if (phone.length == 10) {
				return phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
            } else if (phone.length == 11) {
                if (phone[0] == "0") {
                    return phone.replace(/^(\d{1})(\d{2})(\d{4})(\d{4})/, "$1 ($2) $3-$4");
                } else {
                    return phone.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
                }
            } else if (phone.length == 13) {
				return phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4");
			}
		},

        calcPercent: function(current, total) {
            this.percent = parseInt((current * 100) / total);
        },

        // Fecha o modal
		close: function() {
            if (!this.loading) {
                this.$emit("close");
            }
		},
	}
}
</script>

<style scoped>
.modal-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: #00000044;
	z-index: 3;
}

.modal-container {
	position: absolute;
	margin: auto;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	border-radius: 4px;
}

.modal-container-mini {
	width: 600px;
	height: 240px;
}

.modal-container-full {
	width: calc(100vw - 30px);
	height: calc(100vh - 30px);
}

.modal-header {
	position: relative;
	border-bottom: 1px solid #ddd;
	min-height: 50px;
	padding: 15px;
	font-weight: bold;
	background: #f9f9f9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.modal-close {
	position: absolute;
	top: 12px;
	right: 15px;
	font-size: 20px;
	background: none;
	border: none;
	color: #999;
}

.modal-body {
	padding: 15px;
	width: 100%;
	overflow-y: auto;
}

.modal-body-mini {
	height: 130px;
}

.modal-body-full {
    height: calc(100vh - 140px);
}

.modal-footer {
	position: absolute;
	bottom: 0;
	height: 61px;
	padding: 15px;
	width: 100%;
	border-top: 1px solid #ddd;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

.btn-sync {
	width: 100%;
	height: 40px;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
}
.btn-sync:disabled {
    background: #a0a0a0;
}

/*.btn-margin-top {
    margin-top: 30px;
}*/

.sync-list {
	position: relative;
	height: 100%;
	overflow: hidden;
}

.sync-list-container {
	float: left;
	width: 100%;
	height: 100%;
	overflow: auto;
	padding-bottom: 15px;
}

.sync-list-item {
	width: 100%;
	float: left;
	background: #eee;
	margin-bottom: 15px;
	padding: 10px;
}

.sync-list-synchronized-name {
	float: left;
	width: 80%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
	font-weight: bold;
}

.sync-list-uploading-status {
	float: left;
	width: 20%;
	font-size: 14px;
	text-align: right;
	color: #999;
}

.sync-list-result-collapse { 
	margin-top: 5px;
	margin-bottom: 5px;
}

.sync-list-result-collapse-header {
	width: 100%;
	padding-top: 5px;
	padding-bottom: 5px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
}

.sync-list-result-collapse-body {
	width: 100%;
	padding-left: 10px;
	white-space: nowrap;
	font-size: 11px;
}

.capitalized {
	text-transform: capitalize;
}

.pointer {
    cursor: pointer;
}

.text-center {
    text-align: center;
}

.text-right {
    text-align: right;
}

.list {
    margin-bottom: 30px;
}

.list-name, 
.list-search, 
.list-total {
    display: grid;
    align-content: center;
}

.list-name, 
.list-total {
    border-bottom: 1px solid #ccc;
}

.list-name > h4, 
.list-total > h4 {
    margin-top: 0px;
    margin-bottom: 5px;
}

.list-total > h4 {
    font-size: 1;
    font-weight: 400;
}

.list-head-item {
    /*font-size: 14px;*/
    font-weight: 600;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
    background-color: #eee;
}

.list-body-item {
    /*font-size: 14px;*/
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #ccc;
	border-radius: 3px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
    margin-top: 5px;
}

.list-body-item:hover {
    background-color: #f0f0f0;
}

.list-body-item-cell {
    display: grid;
    align-content: center;
}

.list-body-item-text {
    display: grid;
	align-content: center;
}

.list-body-item-text.resume {
    font-size: 13px;
}

.modal-button-close {
	background: #222;
	border: 2px solid #222;
	color: #fff;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
    margin-right: 15px;
}

.modal-button-back {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-research {
	float: right;
    margin-right: 15px;
	background: #fff;
	border: 2px solid #222 !important;
    color: #222;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}

.modal-button-save:disabled,
.modal-button-research:disabled,
.modal-button-back:disabled,
.modal-button-close:disabled {
	cursor: not-allowed;
	opacity: 0.4;
}

.loading {
    position: absolute;
    top: 50px;
    left: 0;
    background: rgba(255,255,255,.7);
    color: #222;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
}

.loading-mini {
    width: 600px;
    height: 129px;
    line-height: 129px;
}

.loading-full {
    width: calc(100vw - 30px);
	height: calc(100vh - 141px);
    line-height: calc(100vh - 141px);
}

.loading-icon, 
.loading-percent {
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 5px 20px 20px;
    font-size: 20px;
    z-index: 10;
}

.loading-text {
    border-top: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: #f5f5f5;
    padding: 20px 20px 20px 5px;
    font-size: 20px;
    z-index: 10;
}

.error {
    color: red;
}

.success {
    color: green;
}

.gray {
    color: #ddd;
}

.map {
    height: calc(100vh - 170px) !important;
}

.card-map {
	position: absolute;
}

.card {
    height: auto !important;
    width: 370px;
	margin-top: 10px;
	margin-left: 5px;
    background: #fff;
    z-index: 3;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
}

.card-head {
    padding: 10px;
    background-color: #a6a6a6;
	color: rgb(44, 62, 80);
    font-size: 16px;
}

.card-body {
	height: auto !important;
    max-height: calc(100vh - 230px);
    padding: 10px 10px 0px 10px !important;
    background-color: #fff;
	overflow-y: auto;
}

.address-info-body-inner {
	float: left;
	width: 100%;
	border: 1px solid #f5f5f5;
	padding: 0 5px;
    margin-bottom: 10px;
}

.address-info-item {
	position: relative;
    padding: 10px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.address-info-item-left {
    display: grid;
    align-content: center;
    padding-right: 0px !important;
}

.address-info-item-right {
    display: grid;
    align-content: center;
    padding-left: 0px !important;
    font-size: 13px;
}

.card-body-customer {
    float: left;
    width: 100%;
	border-bottom-left-radius: 2px;
	border-bottom-right-radius: 2px;
    /*padding: 10px;*/
}

.card-body-customer-item {
	position: relative;
    padding: 10px 15px;
    float: left;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
}

.card-body-customer-left {
    width: 50%;
    float: left;
    font-size: 12px;
    font-weight: bold;
	display: grid;
    align-content: center;
}

.card-body-customer-right {
    width: 50%;
    float: right;
    text-align: right;
    font-size: 12px;
}

.card-body-address {
    font-size: 14px;
    font-weight: bold;
}

.text-empty {
    /*font-style: italic;*/
    color: #aaa;
}
</style>